"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CreateNew/withParticipantsLookup.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');
var _Props = require('web/components/Form/Props');







var _helpers = require('./helpers');
var _uuid = require('shared/services/uuid');
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _log = require('shared/log');
var _alertReducer = require('shared/reducers/alertReducer');
var _user = require('shared/selectors/user');
var _blobject = require('shared/selectors/blobject');
var _team = require('shared/selectors/team');
var _peers = require('shared/selectors/peers');
var _mapSearchResultsToEntities = require('shared/hooks/createNew/useSearch/mapSearchResultsToEntities');
var _hooks = require('web/services/hooks');









const SEARCH_DELAY_TIME = 500

const CreateNewChatActionTypes = {
  CREATE_CONTACT: "CREATE_CONTACT",
} 














































const directoryLookup = (req) =>
  _actions2.default.directoryLookup(req ) 





const createPatient = (req) =>
  _actions2.default.createPatient(req ) 

const EMPTY_SEARCH_RESULTS = { users: [], teams: [], patients: [] }

const isPersonACandidate = (person) =>
  person.type === _Props.ENTITY_TYPES.UNKNOWN

const isCandidateValid = (c) => [_helpers.isThisAnEmail, _helpers.isThisAPhoneNumber].some(f => f(c))

 function withParticipantsLookup (
  ViewComponent,
) {
  const ParticipantsPicker = props => {
    const {
      selectedOptions, onOptionUpdated, onOptionRemoved,
      inputId, inputValue, onInputChange,
      orgKeyContext, blobjectKeyContext,
    } = props

    const [searchResults, setSearchResults] = _react.useState(EMPTY_SEARCH_RESULTS)

    const currentUserOrgKeys = _hooks.useAppSelector.call(void 0, state => {
      const currentUser = _user.selectCurrentUserV2.call(void 0, state)
      return Object.values(currentUser.Relationships)
        .filter(r => !r.Pending)
        .map(r => r.OrgKey)
    }, _reactredux.shallowEqual)

    const existingEntityIds = _hooks.useAppSelector.call(void 0, state => {
      if (!blobjectKeyContext) return []
      const blobject = _blobject.selectBlobjectByKey.call(void 0, state, blobjectKeyContext)

      // SAFETY: subscriber maps are keyed by team and user keys.
      const blobjectTeams = Object.keys(blobject.TeamSubscribers)
        .map(tk => _team.selectTeamByKey.call(void 0, state, tk ))
        .filter(t => !!t)
      const blobjectUsers = Object.keys(blobject.UserSubscribers)
        .map(uk => _peers.selectUserV2ByKey.call(void 0, state, uk ))
        .filter(u => !!u)

      return [
        ...blobjectUsers.map(u => u.UserKey),
        ...blobjectTeams.map(t => t.TeamKey),
      ]
    }, _reactredux.shallowEqual)

    // Timers and promises read the latest props, as the class read this.props.
    const latest = _react.useRef.call(void 0, { props, currentUserOrgKeys, existingEntityIds })
    _react.useLayoutEffect.call(void 0, () => {
      latest.current = { props, currentUserOrgKeys, existingEntityIds }
    })

    const searchTimeout = _react.useRef(null)
    const clearSearchTimeout = () => {
      if (searchTimeout.current) clearTimeout(searchTimeout.current)
    }

    _react.useEffect.call(void 0, () => clearSearchTimeout, [])

    const clearState = _react.useCallback.call(void 0, () => {
      setSearchResults(EMPTY_SEARCH_RESULTS)
    }, [])

    const isNotCurrentlySelected = (entity) => {
      const { props: { selectedOptions: selected }, existingEntityIds: existingIds } = latest.current

      return !selected
        .map(e => e.id)
        .concat(existingIds)
        .find(id => id === entity.id)
    }

    const runSearch = () => {
      const { props: { orgKeyContext: orgKey, inputValue: value }, currentUserOrgKeys: orgKeys } = latest.current

      const searchValue = _helpers.isThisAPhoneNumber.call(void 0, value)
        ? _helpers.stripSpecialCharactersFromValue.call(void 0, value)
        : value
      if (searchValue.length < 2) return clearState()

      directoryLookup({
        Query: searchValue,
        ...(orgKey ? { PatientOrgKey: orgKey } : {}),
      })
        .then(res => {
          setSearchResults({
            users: _helpers.mapUserResultsToEntities.call(void 0, res, orgKeys)
              .filter(isNotCurrentlySelected)
              .slice(0, 10),
            teams: _helpers.mapTeamResultsToEntities.call(void 0, res)
              .filter(isNotCurrentlySelected)
              .slice(0, 10),
            patients: _helpers.mapPatientResultsToEntities.call(void 0, {
              ...res,
              Patients: _mapSearchResultsToEntities.filterPatientsToOrgContext.call(void 0, 
                Object.values(res.Patients || {}),
                orgKey,
              ),
            })
              .filter(isNotCurrentlySelected)
              .slice(0, 10),
          })
        })
        .catch(err => {
          _log.log.error(err)
        })
    }

    // componentDidUpdate on inputValue: debounce a search, or clear on empty.
    const prevInputValue = _react.useRef.call(void 0, inputValue)
    _react.useEffect.call(void 0, () => {
      const prev = prevInputValue.current
      prevInputValue.current = inputValue
      const isEmpty = (x) => x.length === 0

      if (isEmpty(inputValue) && !isEmpty(prev)) {
        clearState()
      } else if (!isEmpty(inputValue) && inputValue !== prev) {
        clearSearchTimeout()
        searchTimeout.current = setTimeout(runSearch, SEARCH_DELAY_TIME)
      }
      // runSearch reads the latest props through a ref.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue, clearState])

    const onOptionSelected = _react.useCallback.call(void 0, (entity) => {
      latest.current.props.onOptionSelected(entity)
      clearState()
    }, [clearState])

    const onActionSelected = _react.useCallback.call(void 0, (id) => {
      if (!(id in CreateNewChatActionTypes)) { return _log.log.error(new Error(`Warning: Unknown action specified CreateNewChat from ChipInput: ${id}`)) }

      const { inputValue: value } = latest.current.props

      if (id === CreateNewChatActionTypes.CREATE_CONTACT) {
        if (!isCandidateValid(value)) return

        onOptionSelected({
          avatar: { text: '?' },
          id: _uuid.uuidv4.call(void 0, ),
          title: value,
          type: _Props.ENTITY_TYPES.UNKNOWN,
        })
      }
    }, [onOptionSelected])

    const updateCandidateStatus = _react.useCallback.call(void 0, (candidateKey, newStatus) => {
      const {
        orgKeyContext: orgKey,
        selectedOptions: selected,
        onOptionUpdated: onUpdated,
        onOptionRemoved: onRemoved,
      } = latest.current.props

      const affectedEntity = selected.find(e => e.id === candidateKey)
      if (!affectedEntity) return

      /* todo: replace with create user backend call */
      if (newStatus === 'user') {
        return onUpdated({
          ...affectedEntity,
          type: _Props.ENTITY_TYPES.NEWUSER,
        })
      }

      if (newStatus === 'patient') {
        const phone = _helpers.isThisAPhoneNumber.call(void 0, affectedEntity.title)
          ? affectedEntity.title : ''
        const email = _helpers.isThisAnEmail.call(void 0, affectedEntity.title)
          ? affectedEntity.title : ''

        if (!phone && !email) { return _log.log.error(new Error(`Can't create patient. Invalid email or phone number ${affectedEntity.title}`)) }

        if (!orgKey) { return _log.log.error(new Error("How did we get here? User shouldn't have been able to select patient since there is no orgKeyContext")) }

        createPatient({ OrgKey: orgKey, Email: email, Phone: phone })
          .then(res => {
            const newEntity = _helpers.mapPatientResultsToEntities.call(void 0, { Orgs: res.orgs, Patients: res.patients })[0]
            /* Remember we are using different keys here
               * (a fake id was generated for the new patient
               * before it was sent to the backend)
              */
            onRemoved(affectedEntity.id)
            onOptionSelected(newEntity)
          })
          .catch(err => {
            _actions2.default.pushAlert("Error", err.Error, _alertReducer.AlertTypes.ERROR)
            _log.log.error(err)
          })
      }
    }, [onOptionSelected])

    const shouldInviteUser = isCandidateValid(inputValue)
    const inviteUserActionId = shouldInviteUser
      ? CreateNewChatActionTypes.CREATE_CONTACT
      : null

    const { teams, patients, users } = searchResults

    return (
      _react2.default.createElement(ViewComponent, {
        onInputChange: onInputChange,
        inputValue: inputValue,
        inputId: inputId,
        selectedOptions: selectedOptions,
        users: users,
        teams: teams,
        patients: patients,
        inviteUserActionId: inviteUserActionId,
        orgKeyContext: orgKeyContext,
        onOptionSelected: onOptionSelected,
        isCandidateValid: isCandidateValid,
        onActionSelected: onActionSelected,
        isPersonACandidate: isPersonACandidate,
        updateCandidateStatus: updateCandidateStatus,
        onOptionUpdated: onOptionUpdated,
        onOptionRemoved: onOptionRemoved, __self: this, __source: {fileName: _jsxFileName, lineNumber: 291}}
      )
    )
  }

  // connect() made the wrapper pure; React.memo keeps that boundary.
  return _react2.default.memo(ParticipantsPicker)
} exports.default = withParticipantsLookup;
